/**
 * MyBricks Opensource
 * https://mybricks.world
 * This source code is licensed under the MIT license.
 *
 * CheMingjun @2019
 * mybricks@126.com
 */
export default {
    '@inputUpdated': function (_a, _b) {
        var output = _a.output;
        var id = _b.id, schema = _b.schema;
        if (id === 'set') {
            var returnPin = output.get('return');
            returnPin.setSchema(schema); //follow
            var changedPin = output.get('changed');
            changedPin.setSchema(schema); //follow
        }
    },
    '@inputDisConnected': function (_a, from, to) {
        var output = _a.output;
        if (to.id === 'set') {
            var returnPin = output.get('return');
            returnPin.setSchema({ type: 'unknown' });
            var changedPin = output.get('changed');
            changedPin.setSchema({ type: 'unknown' });
        }
    },
    ':root': [
        {
            title: '变量名称',
            type: 'text',
            value: {
                get: function (_a) {
                    var title = _a.title;
                    return title;
                },
                set: function (_a, title) {
                    var setTitle = _a.setTitle;
                    setTitle(title);
                }
            }
        },
        {
            title: '类型',
            type: '_schema',
            value: {
                get: function (_a) {
                    var outputs = _a.outputs;
                    var returnPin = outputs.get('return');
                    return returnPin.schema;
                },
                set: function (_a, schema) {
                    var outputs = _a.outputs;
                    var allPins = outputs.get();
                    allPins.forEach(function (pin) {
                        outputs.get(pin.id).setSchema(schema);
                    });
                }
            }
        }
    ]
};
